export const ERROR_TYPE_ROUTER = 'router'
export const ERROR_TYPE_FATAL = 'fatal'
